import React from "react";
import { useTranslation } from "utilities/i18n";
import { NavLink, Route } from "polyrouter";
import { PolyIcon } from "elements";
import { useUserMeta } from "utilities/userMeta";
import { InventoryView } from "generated/graphql";

export const ViewSelector: React.FC<{ className?: string }> = props => {
  const { t } = useTranslation();
  const [setUserMeta] = useUserMeta();
  const classes = props.className ? " " + props.className : "";

  const setView = (view: InventoryView) => {
    setUserMeta({ inventorySessionState: view }, false);
  };

  return (
    <Route exact path="/manage/:focus/:view">
      <Route
        render={({ match }) => (
          <div className={`view-selector ${classes}`}>
            <NavLink
              to={`/manage/${match.params.focus}/map`}
              persist={["DeviceFilterState"]}
              onClick={() => setView(InventoryView.Map)}
              data-testid="map-link"
            >
              <PolyIcon icon="map" title={t("VIEW_MAP")} />
              <span className="sr-only">{t("VIEW_DATA_AS_MAP")}</span>
            </NavLink>
            <NavLink
              to={`/manage/${match.params.focus}/table`}
              persist={["DeviceFilterState"]}
              onClick={() => setView(InventoryView.List)}
              data-testid="table-link"
            >
              <PolyIcon icon="list" title={t("VIEW_LIST")} />
              <span className="sr-only">{t("VIEW_DATA_AS_LIST")}</span>
            </NavLink>
          </div>
        )}
      />
    </Route>
  );
};

export default ViewSelector;
